// import { useState, useEffect } from "react";
// import { Frame, Loading, Header, Input } from "../components";
// import { useNavigate } from "react-router-dom";
// import { db, auth, storage } from "../config/firebase";
// import { doc, getDoc, setDoc } from "firebase/firestore";
// import { onAuthStateChanged } from "firebase/auth";
// import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// import { Button, Modal } from "react-bootstrap";

const Vinculo = () => {
  // const [dados, setDados] = useState({});
  // const [modal, setModal] = useState(false);
  // const [loading, setLoading] = useState(true);
  // let uid = auth.currentUser?.uid;
  // const navigate = useNavigate();
  // const openModal = () => setModal(true);
  // const closeModal = () => setModal(false);
  // const uploadFile = async (file, docPath, docUrl) => {
  //   if (!file) return;
  //   setLoading(true);
  //   const path = ref(storage, `ebserh2025/${uid}/${docPath}`);
  //   const upload = uploadBytesResumable(path, file, file.type);
  //   upload.on(
  //     "state_changed",
  //     () => {},
  //     () => {},
  //     () => {
  //       getDownloadURL(upload.snapshot.ref).then((url) => {
  //         setDados({ ...dados, [docUrl]: url });
  //         setLoading(false);
  //       });
  //     }
  //   );
  // };
  // const setData = async () => {
  //   await setDoc(doc(db, "ebserh2026", uid), dados, { merge: true });
  // };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   await setData();
  //   setLoading(false);
  //   openModal();
  // };
  // const getData = async () => {
  //   const qry = await getDoc(doc(db, "ebserh2026", uid));
  //   const data = qry.data();
  //   if (data.anoAtual === "2025" && data.status === "a") {
  //     setDados(data);
  //     setLoading(false);
  //   } else {
  //     navigate("../home");
  //   }
  // };
  // const checkLogin = async () => {
  //   if (uid) getData();
  //   else
  //     onAuthStateChanged(auth, (user) => {
  //       if (user?.uid) {
  //         uid = user.uid;
  //         getData();
  //       } else navigate("../login");
  //     });
  // };
  // useEffect(() => {
  //   checkLogin();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // return (
  //   <>
  //     {loading && <Loading />}
  //     <Modal show={modal} onHide={closeModal}>
  //       <Modal.Header closeButton>
  //         <Modal.Title>Aviso</Modal.Title>
  //       </Modal.Header>
  //       <Modal.Body>Documento atualizado com sucesso.</Modal.Body>
  //       <Modal.Footer>
  //         <Button variant="primary" onClick={closeModal}>
  //           Fechar
  //         </Button>
  //       </Modal.Footer>
  //     </Modal>
  //     <Header nome={dados?.nome} foto={dados?.urlFoto} />
  //     <Frame
  //       body={
  //         <form
  //           autoComplete="off"
  //           onSubmit={handleSubmit}
  //           className="text-start"
  //           noValidate
  //         >
  //           <div className="row mt-3">
  //             <div className="text-center">
  //               <p>Por gentileza, atualize seu comprovante de vínculo.</p>
  //             </div>
  //             <div className="col-sm-12">
  //               <Input
  //                 id="imgVinculo"
  //                 label="Comprovante de Vínculo"
  //                 type="file"
  //                 accept=".jpg, .jpeg, .png, .pdf"
  //                 onChange={(e) =>
  //                   uploadFile(e.target.files[0], "vinculo", "urlVinculo")
  //                 }
  //               />
  //             </div>
  //             {dados?.urlVinculo && (
  //               <a
  //                 href={dados?.urlVinculo}
  //                 target="_blank"
  //                 rel="noreferrer"
  //                 className="dark m-2"
  //               >
  //                 🔎 Ver documento enviado
  //               </a>
  //             )}
  //           </div>
  //           <div className="row mt-3">
  //             <div className="col-sm-12 d-grid">
  //               <button type="submit" className="btn btn-primary">
  //                 ENVIAR
  //               </button>
  //             </div>
  //           </div>
  //         </form>
  //       }
  //       title="Atualizar Comprovante de Vínculo"
  //     />
  //   </>
  // );
};

export default Vinculo;
